import React, { useState, useEffect } from "react";
import axios from "axios";
// var mod1 = require('../../../../src/Baseurl');
import Baseurl from "../../../Baseurl";
import swal from "sweetalert";
import { useHistory } from "react-router-dom";
import { Modal } from "react-bootstrap";
function CustomerNotification() {
  var history = useHistory();
  const [name, setName] = useState("");
  const [show, setShow] = useState(false);
  useEffect(() => {}, []);

  const submitHandler = () => {
    const data = new FormData();
    let testJson = {
      title: tittle,
      body: body,
      category: type,
      summaryText: summary,
      packageTestId: packageId,
    };
    data.append("data", JSON.stringify(testJson));
    data.append("image", image);
    var config = {
      method: "post",
      url: `${Baseurl.baseurl}/admin/send-all-user-notification`,
      data: data,
    };

    axios(config)
      .then(function (response) {
        if (response.data.status) {
          setBody("");
          setImage(null);
          setImageData(null);
          setTittle("");
          setSummary("");
          setPackageId("");
          swal("Notification Sent", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
          setShow(false);
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
  };
  const [type, setType] = useState("Normal");
  const [packageId, setPackageId] = useState("");
  const TypesObject = ["Normal", "Image"];
  const [tittle, setTittle] = useState("");
  const [body, setBody] = useState("");
  const [imageData, setImageData] = useState(null);
  const [image, setImage] = useState(null);
  const onChangePicture = (e) => {
    if (e.target.files[0].size / 1048576 < 3) {
      setImage(e.target.files[0]);
      if (e.target.files[0]) {
        const reader = new FileReader();
        reader.addEventListener("load", () => {
          setImageData(reader.result);
        });
        reader.readAsDataURL(e.target.files[0]);
      }
    } else {
      swal("Oops", "image size should be less than 3MB", "error", {
        button: "Done",
        timer: 2000,
      });
      setImageData(null);
    }
  };
  const [summary, setSummary] = useState("");
  return (
    <div className="row">
      <Modal
        show={show}
        onHide={() => {
          setShow(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Send Notification</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h4>Are You Sure You Want to send Notification ?</h4>
        </Modal.Body>
        <Modal.Footer>
          <button
            onClick={() => {
              submitHandler();
            }}
            className="btn btn-primary"
          >
            Send
          </button>
        </Modal.Footer>
      </Modal>
      <div className="col-xl-12 col-lg-12">
        <div
          className="card"
          style={{
            color: "white",
            background:
              "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
          }}
        >
          <div className="card-header">
            <h4 className="card-title text-white">Send Notification</h4>
          </div>
          <div className="card-body">
            <div className="basic-form">
              <form
                onSubmit={(e) => {
                  setShow(true);
                  e.preventDefault();
                }}
              >
                <div className="row">
                  <div className="col-sm-6">
                    <label>
                      Type <span className="text-danger">*</span>
                    </label>
                    <select
                      className="col-sm-12 text-primary p-2 custom-select bg-white"
                      id="val-skill"
                      name="val-skill"
                      placeholder="Select Search Item"
                      defaultValue={type}
                      onChange={(event) => {
                        setType(event.target.value);
                      }}
                    >
                      {TypesObject &&
                        TypesObject.map((val) => (
                          <option value={val}>{val}</option>
                        ))}
                    </select>
                  </div>
                  <div className="col-sm-6">
                    <label>
                      Tittle <span className="text-danger">*</span>
                    </label>
                    <input
                      value={tittle}
                      type="text"
                      className="form-control"
                      placeholder="enter tittle"
                      onChange={(e) => setTittle(e.target.value)}
                      required
                    />
                  </div>
                </div>
                <div className="row mt-4">
                  {type === "Normal" ? (
                    <div className="col-sm-6">
                      <label>
                        Body <span className="text-danger">*</span>
                      </label>
                      <input
                        value={body}
                        type="text"
                        className="form-control"
                        placeholder="enter body"
                        onChange={(e) => setBody(e.target.value)}
                        required
                      />
                    </div>
                  ) : (
                    <>
                      <div className="col-sm-6">
                        <label htmlFor="val-range">
                          Image
                          <span className="text-danger">*</span>
                        </label>
                        <div className="register_profile_image mt-2">
                          <input
                            id="profilePic"
                            type="file"
                            onChange={(e) => {
                              onChangePicture(e);
                            }}
                          />
                        </div>
                        {imageData && (
                          <div
                            style={{
                              marginTop: "5px",
                              width: 180,
                              height: 100,
                              aspectRatio: 1 * 1.4,
                            }}
                            className="previewProfilePic"
                          >
                            <img
                              alt=""
                              className="playerProfilePic_home_tile"
                              style={{
                                resizeMode: "cover",
                                width: "100%",
                                height: "100%",
                              }}
                              src={imageData}
                            />
                          </div>
                        )}
                      </div>
                      <div className="col-sm-6">
                        <label>
                          <strong>Summary</strong>
                        </label>
                        <textarea
                          value={summary}
                          type="text"
                          className="form-control"
                          placeholder="enter message"
                          onChange={(e) => setSummary(e.target.value)}
                          required
                        />
                      </div>
                    </>
                  )}
                  <div className={`col-sm-6 ${type !== "Normal" && "mt-4"}`}>
                    <label>
                      Test Or Package Id <span className="text-danger">*</span>
                    </label>
                    <input
                      value={packageId}
                      type="text"
                      className="form-control"
                      placeholder="copy and paste the test or package id"
                      onChange={(e) => setPackageId(e.target.value)}
                      required
                    />
                  </div>
                </div>
                <div className="col-sm-2 mt-4 float-right">
                  <input
                    className="btn btn-primary"
                    type="submit"
                    value="Send"
                  />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CustomerNotification;
